<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/employment" class="opacity-50 hover:opacity-100">Employment</router-link>
                        <span class="mx-2">/</span>
                        <span>Job Opportunities</span>
                    </div>
                    <div class="font-bold">Job Opportunities</div>
                </div>
                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="w-full flex bg-secondary text-white px-8 pt-6 rounded-t-xl">
                        <div v-for="(tab, index) in tabs" :key="index"
                            class="px-4 py-2 mr-4 cursor-pointer rounded-t-lg" @click="selectTab(tab.id)"
                            :class="activeTab == tab.id ? 'text-ternary font-bold bg-white' : 'bg-ternary text-white'">
                            {{ tab.name }}</div>
                    </div>
                    <div class="w-full">
                        <transition name="fade" mode="out-in">
                            <keep-alive>
                                <component :is="activeTab"></component>
                            </keep-alive>
                        </transition>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import Tab1 from "./job-opportunities/tab-1.vue";
import Tab2 from "./job-opportunities/tab-2.vue";
export default {
    name: "job-opportunities",
    components: {
        Tab1,
        Tab2,
    },
    data() {
        return {
            activeTab: "tab-1",
            tabs: [
                { id: 'tab-1', name: 'Welcome' },
                { id: 'tab-2', name: 'Postings' },
            ],
        };
    },
    methods: {
        selectTab(selectedTab) {
            this.activeTab = selectedTab;
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>